import Form from './form';
import ControlledCarousel from './Slides';
import Header from './Header';

const Body = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <Header />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <ControlledCarousel />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Form />
                </div>
            </div>
        </div>
    );
}

export default Body;
